import React from 'react'
import cx from 'classnames'

import styles from './Textarea.module.scss'

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

export const Textarea = ({ className, ...props }: TextareaProps) => (
  <textarea className={cx(styles.textarea, className)} {...props} />
)
